// @flow

//
// React
//
import React from 'react';

//
// Redux Fantasy
//
import {
    useLocalSelector,
} from '../../../../../lib/redux-fantasy-reducers';

//
// Material UI
//
import Grid from '@mui/material/Grid';

import { makeStyles } from '@mui/styles';

//
// Hal forms
//
import {
	getSelector,
} from '../../../../../lib/trix-web-hal-forms/tools/halFormsRedux';
import withHalFormsAction from '../../../../../lib/trix-web-hal-forms/extender/withHalFormsAction';

//
// Trix Data
//
import {
    hasErrorCausesForLocation,
    formatErrorsForLocation,
} from '../../../../../lib/trix-web-data-commons';

//
// Components
//
import {
    TextFormPaneField,
} from '../../../../../lib/trix-web-components-pane';

//
// Styles
//
const useStyles = makeStyles(theme => ({
    root: {
    },
}));

//
// Props
//
type Props = {
    //
    // Hal Forms
    //
    __form: any,
    __halFormsTemplate: any,
    __halFormsActionExtender: any,
    __ducks: any,

    //
    // Data
    //
    value: any,
    data: any,
    container: any,

    //
    // Error
    //
    error: any,

    //
    // Handlers
    //
    onChange: (value: any, meta: any) => any,
    onClose: () => any,
};

//
// Component
//
const PackSaleOrderStockBarcodeField = (props: Props) => {
    //
    // Hooks
    //
    const pageInstanceState = useLocalSelector (s => s);
    const classes = useStyles();
    // End hooks

    const action = props.__form.actions.find(a => a.name === 'onPackSaleOrderStock');
    const inProgress = getSelector (props.__ducks) (action.id) ('isInProgress') (pageInstanceState);

    return (
        <Grid container direction='column' className={classes.root}>
            <TextFormPaneField
                autoFocus={true}
                disabled={inProgress}
                label={props.__halFormsTemplate.title}
                description={props.__halFormsTemplate.description}

                value={props.value}
                error={props.error}

                onChange={props.onChange}
                onKeyDown={(e) => {
                    if (e.keyCode == 13) {
                        // find onComplete action
                        props.__halFormsActionExtender.executeHalFormsAction(action,
                            props.data, props.container, {
                                onSuccess: (data: any) => {
                                    props.onChange('', {
                                        path: props.__halFormsTemplate.name
                                    });
                                }
                            }
                        );
                    }
                }}

                dataPath={props.__halFormsTemplate.name}
            />

        </Grid>
    );
};
export default withHalFormsAction ({}) (PackSaleOrderStockBarcodeField);